import { Route } from "react-router-dom";
import Protected from "../../auth/Protected";
import { UserRole } from "../../../enums";
import ShoppingCompaniesPage from "./shopping-companies-page";
import ShoppingCompanyCreatePage from "./shopping-company-create-page";
import ShoppingCompanyEditPage from "./shopping-company-edit-page";

export default (
  <Route path="shopping-companies">
    <Route
      index
      element={
        <Protected
          path="/admin/shopping-companies"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <ShoppingCompaniesPage />
        </Protected>
      }
    />

    <Route
      path="create"
      element={
        <Protected
          path="/admin/shopping-companies/create"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <ShoppingCompanyCreatePage />
        </Protected>
      }
    />

    <Route
      path="edit/:id"
      element={
        <Protected
          path="/admin/shopping-companies/edit/:id"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <ShoppingCompanyEditPage />
        </Protected>
      }
    />
  </Route>
);
